import { authAPIBase } from 'app/utilities/env';
import axios, { AxiosResponse } from 'axios';

import {
  TResendAccountVerificationResponse,
  TResetPasswordServerResponse,
  TSignInDTO,
  TSignInServerResponse,
  TSignUpDTO,
  TSignUpServerResponse,
  TValidateResetPasswordServerResponse,
} from '../types';

const axiosInstance = axios.create({ baseURL: authAPIBase });

export const signInAPIRequest = async (data: TSignInDTO) => {
  const response: AxiosResponse<TSignInServerResponse> =
    await axiosInstance.post('/login', data);
  return response.data;
};

export const signUpAPIRequest = async (data: TSignUpDTO) => {
  const { referralCode, ...payload } = data;
  const response: AxiosResponse<TSignUpServerResponse> =
    await axiosInstance.post('/register', payload, {
      params: {
        referralCode,
      },
    });
  return response.data;
};

export const verifyAccountAPIRequest = async (token: string) => {
  const response: AxiosResponse<TValidateResetPasswordServerResponse> =
    await axiosInstance.post('/verify', { token });
  return response.data;
};

export const resetPasswordAPIRequest = async (email: string) => {
  const response: AxiosResponse<TResetPasswordServerResponse> =
    await axiosInstance.post('/reset-password', { email });
  return response.data;
};

export const validateResetTokenAPIRequest = async (token: string) => {
  const response: AxiosResponse<TValidateResetPasswordServerResponse> =
    await axiosInstance.post('/validate-reset-password', {
      token,
    });
  return response.data;
};

export const updatePasswordAPIRequest = async (data: TSignInDTO) => {
  const response: AxiosResponse<TValidateResetPasswordServerResponse> =
    await axiosInstance.post('/update-password', data);
  return response.data;
};

export const resendVerifyEmailAPIRequest = async (email: string) => {
  const response: AxiosResponse<TResendAccountVerificationResponse> =
    await axiosInstance.post('resend-verification', { email });
  return response.data;
};

export const resendPasswordResetEmailAPIRequest = async (email: string) => {
  const response: AxiosResponse<TResetPasswordServerResponse> =
    await axiosInstance.post('resend-reset-password', { email });
  return response.data;
};

export const logoutAPIRequest = async (token: string) => {
  const response = await axiosInstance.post(
    '/logout',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
